import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import MisDestinariosContent from "./MisDestinatariosContent"


interface ChildsProps {
    logout: () => void
}


const MisDestinatarios: React.FC<ChildsProps> = ({logout}) => {

    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
        <div className="main-container" id="container">
            <SideBar/>
            <MisDestinariosContent/>
        </div>
    </div>
    )
}


export default MisDestinatarios